export default {
  namespaced: true,

  state: () => ({
    mainMenu: [],
    footerMenu: [],
    categoryMenu: [],
    infoMenu: [],
    scrollableMenuEl: null,

  }),

  getters: {
    mainMenu: (state) => state.mainMenu,
    categoryMenu: (state) => state.categoryMenu,
    footerMenu: (state) => state.footerMenu?.[0] || [],
    infoMenu: (state) => state.infoMenu || [],
    scrollableMenuEl: (state) => state.scrollableMenuEl,
  },

  mutations: {
    setMainMenu: (state, payload = []) => {
      state.mainMenu = payload;
    },

    setFooterMenu: (state, menu = []) => {
      state.footerMenu = menu;
    },

    setCategoryMenu: (state, menu = []) => {
      state.categoryMenu = menu;
    },

    setInfoMenu: (state, menu = []) => {
      state.infoMenu = menu;
    },

    setScrollableMenu: (state, el) => {
      state.scrollableMenuEl = el;
    },
  },

  actions: {
    loadMainMenu({ commit }) {
      return this.$api.loadMenu(['main_menu'])
        // eslint-disable-next-line camelcase
        .then(({ main_menu = [] } = {}) => {
          commit('setMainMenu', main_menu);
        })
        .catch(() => {
          commit('setMainMenu');
        });
    },

    loadFooterMenu({ commit }, slot = 'footer_menu') {
      // тянем их по отдельности,
      // проверить быстрее ли будет работать распаралеливание
      return this.$api.loadMenu([slot])
        .then((menu = {}) => {
          commit('setFooterMenu', menu[slot]);
        })
        .catch(() => {});
    },

    loadInfoMenu({ commit }, slot = 'info_menu') {
      return this.$api.loadMenu([slot])
        .then((menu = {}) => {
          commit('setInfoMenu', menu[slot]);
        })
        .catch(() => {});
    },
  },
};
